export const initFocusVisible = () => import('focus-visible').catch(() => {});
